export var LocalStorageAttributes = /*#__PURE__*/ function(LocalStorageAttributes) {
    LocalStorageAttributes["IsResumeCopilotConsentGiven"] = "isResumeCopilotConsentGiven";
    return LocalStorageAttributes;
}({});
var LoginTypeAllowedAttributes = {
    Contractor: [
        'isResumeCopilotConsentGiven'
    ],
    Client: [
        ''
    ],
    Employer: [
        ''
    ],
    Customer: [
        ''
    ],
    Support: [
        ''
    ],
    GorillaResume: [
        ''
    ]
};
var isAttributeExists = function(attribute) {
    var _LoginTypeAllowedAttributes_loginType;
    var loginType = localStorage.getItem('loginType');
    return (_LoginTypeAllowedAttributes_loginType = LoginTypeAllowedAttributes[loginType]) === null || _LoginTypeAllowedAttributes_loginType === void 0 ? void 0 : _LoginTypeAllowedAttributes_loginType.includes(attribute);
};
export var setProtectedLocalStorageAttribute = function(attribute, value) {
    if (isAttributeExists(attribute)) {
        localStorage.setItem(attribute, value);
    }
};
export var removeProtectedLocalStorageAttribute = function(attribute) {
    if (isAttributeExists(attribute)) {
        localStorage.removeItem(attribute);
    }
};
